import { BaseHolding } from './base-holding';
import { EncryptedPartnerFields } from './encrypted-partner-fields.interface';
import { OriginPlatform } from './partner.interface';
import { PortfolioFlags } from './portfolio-flags.interface';

export class BasePortfolio {
	// TODO cleanup: convert these private properties to public and remove corresponding get set methods
	private _applications: Array<string>;
	private _children: Array<BaseHolding>;
	private _childCount: number; // used for IQ
	private _description: string;
	private _designation: string;
	private _flags: PortfolioFlags;
	private _origin: string;
	private _toolOrigin: string;
	private _subType: string;
	private _subTypeKey: string;
	private _type: string;
	private _uniqueId: string;
	private _parentId: string;
	private _portOrder: number;
	private _dateLastModified: string;
	private _lastModifyingUser: string;
	private _currentUserIsOwner: boolean;
	private _lastModifiedDisplayDate: string;
	private _tags: string[];
	private _acTags?: string[];
	private _hasHoldingsError: boolean;
	private _encrypted: EncryptedPartnerFields;
	private _originPlatform: OriginPlatform;

	public get applications(): Array<string> {
		return this._applications;
	}

	public set applications(value: Array<string>) {
		this._applications = value;
	}

	public get children(): Array<BaseHolding> {
		return this._children;
	}

	public set children(value: Array<BaseHolding>) {
		this._children = value;
	}

	// used for IQ - userPortfolios store
	public get childCount(): number {
		return this._childCount;
	}

	public set childCount(value: number) {
		this._childCount = value;
	}

	public get description(): string {
		return this._description;
	}

	public set description(value: string) {
		this._description = value;
	}

	public get designation(): string {
		return this._designation;
	}

	public set designation(value: string) {
		this._designation = value;
	}

	public get encrypted(): EncryptedPartnerFields {
		return this._encrypted;
	}

	public set encrypted(value: EncryptedPartnerFields) {
		this._encrypted = value;
	}

	public get originPlatform(): OriginPlatform {
		return this._originPlatform;
	}

	public set originPlatform(value: OriginPlatform) {
		this._originPlatform = value;
	}

	public get flags(): any {
		return this._flags;
	}

	public set flags(value: any) {
		this._flags = value;
	}

	public get origin(): string {
		return this._origin;
	}

	public set origin(value: string) {
		this._origin = value;
	}

	public get toolOrigin(): string {
		return this._toolOrigin;
	}

	public set toolOrigin(value: string) {
		this._toolOrigin = value;
	}

	public get subType(): string {
		return this._subType;
	}

	public set subType(value: string) {
		this._subType = value;
	}

	public get subTypeKey(): string {
		return this._subTypeKey;
	}

	public set subTypeKey(value: string) {
		this._subTypeKey = value;
	}

	public get type(): string {
		return this._type;
	}

	public set type(value: string) {
		this._type = value;
	}

	public get uniqueId(): string {
		return this._uniqueId;
	}

	public set uniqueId(value: string) {
		this._uniqueId = value;
	}

	public get parentId(): string {
		return this._parentId;
	}

	public set parentId(value: string) {
		this._parentId = value;
	}

	public get portOrder(): number {
		return this._portOrder;
	}

	public set portOrder(value: number) {
		this._portOrder = value;
	}

	public get dateLastModified(): string {
		return this._dateLastModified;
	}

	public set dateLastModified(value: string | number) {
		this._dateLastModified = value?.toString();
	}

	public get lastModifyingUser(): string {
		return this._lastModifyingUser;
	}

	public set lastModifyingUser(user: string) {
		this._lastModifyingUser = user;
	}

	public get currentUserIsOwner(): boolean {
		return this._currentUserIsOwner;
	}

	public set currentUserIsOwner(isOwner: boolean) {
		this._currentUserIsOwner = isOwner;
	}

	public get lastModifiedDisplayDate(): string {
		return this._lastModifiedDisplayDate;
	}

	public set lastModifiedDisplayDate(lastModifiedDisplayDate: string) {
		this._lastModifiedDisplayDate = lastModifiedDisplayDate;
	}

	public get tags(): string[] {
		return this._tags;
	}

	public set tags(tags: string[]) {
		this._tags = tags;
	}

	public get acTags(): string[] {
		return this._acTags;
	}

	public set acTags(tags: string[]) {
		this._acTags = tags;
	}

	public get hasHoldingsError(): boolean {
		return this._hasHoldingsError;
	}

	public set hasHoldingsError(hasHoldingsError: boolean) {
		this._hasHoldingsError = hasHoldingsError;
	}
}
